import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthService from "../../services/AuthService";
import Constants from "./../../Utils/Constants";

// Guards a route element behind auth. Wrap the protected element:
// <Route path={Constants.dashboard} element={<PrivateRoute><Drawer /></PrivateRoute>} />
function PrivateRoute({ children }) {
  const location = useLocation();

  if (!AuthService.isAuthenticated()) {
    return <Navigate to={Constants.login} state={{ from: location }} replace />;
  }

  return children;
}

export default PrivateRoute;
